import React, { ReactElement } from 'react';
import RequestPIConsent from 'src/components/data/RequestPIConsent';
import AccountUpdate from 'src/components/data/AccountUpdate';
import SavedData from 'src/components/data/SavedData';
import CookieSetting from 'src/components/data/CookieSetting';
import useAuth from 'src/hooks/useAuth';
import AccountRegion from 'src/routes/settings/AccountRegion';
import useStyles from 'src/styles/di-theme';
import classNames from 'classnames';
import RequestMalwareScanningConsent from 'src/components/data/RequestMalwareScanningConsent';
import { usePageTitle } from 'src/hooks/useMastheadTitle';
import { Box } from '@barracuda-internal/bds-core-v2';

function DataSettings(): ReactElement {
	usePageTitle('Manage Tenant');
	const { auth } = useAuth();
	const classes = useStyles();
	return (
		<Box
			className={classNames(
				classes['pt_4'],
				classes['m_auto'],
				classes['w_max_720'],
			)}
		>
			{auth?.isFullAdmin() && (
				<Box className={classNames(classes['mb_2'], classes['pt_2'])}>
					<AccountUpdate />
				</Box>
			)}

			<Box
				className={classNames(
					classes['mb_2'],
					classes['pt_2'],
					classes['border_top_gray'],
				)}
			>
				<RequestPIConsent />
			</Box>

			{auth?.isFullAdmin() && (
				<>
					<Box
						className={classNames(
							classes['mb_3'],
							classes['pt_2'],
							classes['pb_1'],
							classes['border_top_gray'],
						)}
					>
						<RequestMalwareScanningConsent />
					</Box>

					<Box
						className={classNames(
							classes['mb_4'],
							classes['pt_2'],
							classes['border_top_gray'],
						)}
					>
						<AccountRegion />
						<br></br>

						<Box
							className={classNames(
								classes['mb_2'],
								classes['border_top_gray'],
								classes['pt_2'],
							)}
						>
							<SavedData></SavedData>
						</Box>
					</Box>
				</>
			)}

			<Box
				className={classNames(
					classes['mb_2'],
					classes['border_top_gray'],
					classes['pt_2'],
				)}
			>
				<CookieSetting></CookieSetting>
			</Box>
		</Box>
	);
}

export default DataSettings;
